var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DP_IDS_HOLDING, DP_TRANSACTION_HISTORY_HOLDING, DP_TRANSACTION_HISTORY_LOADER, DP_TRANSACTION_MAIN_LOADER, EMPTY_DP_TRANSACTION_VALIDATION, HIDE_EMPTY_DP_TRANSACTION_VALIDATION, HOLDING_EMPTY_VALIDATION, HOLDING_ERROR, HOLDING_HIDE_EMPTY_VALIDATION, HOLDING_HIDE_ERROR, HOLDING_LOADER, HOLDING_REPORT, PROD_ASSET_FILTER_VAL_HOLDING, SAVE_SMTF, } from "@redux/interfaces/Reports/iHoldingReport";
// import {
//   DP_IDS_HOLDING,
//   DP_TRANSACTION_HISTORY_HOLDING,
//   DP_TRANSACTION_HISTORY_LOADER,
//   DP_TRANSACTION_MAIN_LOADER,
//   EMPTY_DP_TRANSACTION_VALIDATION,
//   HIDE_EMPTY_DP_TRANSACTION_VALIDATION,
//   HOLDING_EMPTY_VALIDATION,
//   HOLDING_ERROR,
//   HOLDING_HIDE_EMPTY_VALIDATION,
//   HOLDING_HIDE_ERROR,
//   HOLDING_LOADER,
//   HOLDING_REPORT,
//   IHoldingReportReducer,
//   IHoldingReportReducerData,
//   PROD_ASSET_FILTER_VAL_HOLDING,
//   SAVE_SMTF,
// } from "../../interfaces/Reports/iHoldingReport";
var initState = {
    data: {
        HoldingSummary: {
            date: "",
            message: "",
            totalInvestment: "",
            currentValue: "",
            totalPnL: "",
            daysPnL: "",
            totalPnLChange: "",
            daysPnLChange: "",
            // time: ""
        },
        HoldingDetails: [],
        SearchData: "",
        FilterData: {
            simpleFilter: { name: "", filters: [] },
            assetFilter: { name: "", filters: [] },
            productAssetFilter: { name: "", filters: [] },
        },
        loader: false,
        SortData: [],
        IsSummarize: false,
        isOmneOnly: false,
    },
    loader: false,
    downloadStatus: {
        error: null,
        isOpen: null,
    },
    emailStatus: {
        error: null,
        isOpen: null,
    },
    errorData: {
        error: null,
        isOpen: false,
    },
    dpTransactionHistoryErrorData: {
        error: null,
        isOpen: false,
    },
    dpTransactionSubmitErrorData: {
        error: null,
        isOpen: false,
    },
    emptyValidation: {
        icon: null,
        message: null,
    },
    emptyDpTransaction: { icon: "", message: "" },
    dpTransactionEntity: {
        dpIds: [],
        dpTranactions: [],
    },
    dpTransactionLoader: false,
    dpTransactionMainLoader: false,
    prodDropDown: null,
    smtf: false,
};
var holdingReport = function (state, action) {
    var _a, _b;
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case HOLDING_REPORT:
            return __assign(__assign({}, state), { data: action.payload.data });
        case HOLDING_LOADER:
            return __assign(__assign({}, state), { loader: action.payload.loader });
        case HOLDING_ERROR:
            return __assign(__assign({}, state), (_a = {}, _a[action.errorType] = action.payload.errorData, _a));
        case HOLDING_HIDE_ERROR:
            return __assign(__assign({}, state), (_b = {}, _b[action.errorType] = initState[action.errorType], _b));
        case HOLDING_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: action.payload.emptyValidation });
        case EMPTY_DP_TRANSACTION_VALIDATION:
            return __assign(__assign({}, state), { emptyDpTransaction: action.payload.emptyDpTransaction });
        case HOLDING_HIDE_EMPTY_VALIDATION:
            return __assign(__assign({}, state), { emptyValidation: initState.emptyValidation });
        case HIDE_EMPTY_DP_TRANSACTION_VALIDATION:
            return __assign(__assign({}, state), { emptyDpTransaction: initState.emptyDpTransaction });
        case DP_TRANSACTION_HISTORY_HOLDING:
            state.dpTransactionEntity.dpTranactions =
                action.payload.dpTransactionEntity.dpTranactions;
        case DP_TRANSACTION_HISTORY_LOADER:
            return __assign(__assign({}, state), { dpTransactionLoader: action.payload.dpTransactionLoader });
        case DP_TRANSACTION_MAIN_LOADER:
            return __assign(__assign({}, state), { dpTransactionMainLoader: action.payload.dpTransactionMainLoader });
        case DP_IDS_HOLDING:
            state.dpTransactionEntity.dpIds =
                action.payload.dpTransactionEntity.dpIds;
        case PROD_ASSET_FILTER_VAL_HOLDING:
            return __assign(__assign({}, state), { prodDropDown: action.payload.prodDropDown });
        case SAVE_SMTF:
            return __assign(__assign({}, state), { smtf: action.payload.smtf });
        default:
            return __assign({}, state);
    }
};
export default holdingReport;
